import { useSelector } from 'react-redux';
import { getStoreFailure, getStoreLoaded, getStoreLoading, getStoreMeta } from '../../selector';

export const useStoreMetaData = () => ({
  meta: useSelector(getStoreMeta),
  loading: useSelector(getStoreLoading),
  loaded: useSelector(getStoreLoaded),
  failure: useSelector(getStoreFailure),
});
